import { TicketType, OddsChangeType, StakeType, /* OfferType */ } from '../../api/proto/apiContract';
import { IAccountTypeKey, IMoneyWithCurrency } from './mtsTicket';
import { IJavascriptStorage } from '../../services/storageService';

export class TicketStorage {

    private sessionStorage: IJavascriptStorage;

    public constructor(sessionStorage: IJavascriptStorage) {
        this.sessionStorage = sessionStorage;
    }

    public load(key: string, withDateCheck: boolean): ITicketStorageData {
        let data = this.sessionStorage.getItem(key);
        if (data) {
            let parsedData = JSON.parse(data);
            if (!parsedData) {
                return null;
            }
            if (parsedData.stored) {
                parsedData.stored = new Date(parsedData.stored);
            }
            if (withDateCheck && parsedData.stored) {
                if (parsedData.stored.getTime() + 24 * 3600 * 1000 < new Date().getTime()) {
                    this.sessionStorage.removeItem(key);
                    return null;
                }
            }
            return parsedData;
        }
        return null;
    }

    public store(key: string, data: ITicketStorageData): void {
        this.sessionStorage.setItem(key, JSON.stringify(data));
    }

    public remove(key: string) {
        this.sessionStorage.removeItem(key);
    }

    public getKey(userId: number, index: number): string {
        return `ticket_${userId}_${index}`;
    }

}

export interface ITicketStorageData {
    stored: Date;
    ticketType: TicketType;
    stakeType: StakeType;
    oddsChangeType: OddsChangeType,
    selections: ITicketStorageSelection[];
    bets: ITicketStorageBet[];
    totalRate: number | null;
    prizePotential: number | null;
    stake: number | null;
    stakeMoneyForInfo: number | null;
    availableAccountTypes: { key: IAccountTypeKey, name: string, isMoney: boolean, hint: string, stakeValue: number | null, canBeUsedByPlayer: boolean }[];
    selectedAcountType: IAccountTypeKey;
    productFee: IMoneyWithCurrency | null;
    oddsRateAdvantage: number | null;
    rateAdvantageFactor: number | null;
    handlingFeePointsValue: number | null;
    handlingFeeValue: number | null;
}
//TODO_FT: Vratit zpet IAccountTypeKey pro storage
export interface ITicketStorageSelection {  //see also TicketSelection
    id: string;
    fixtureId: number;
    gameId: string;
    rate: number;
    marketName: string;
    tipName: string;
    isBanker: boolean | null;
    sportName: string;
    fixtureName: string;
    fixtureDate: Date;
    indent: string;
    number: number;
    offerType: number;
}

export interface ITicketStorageBet {
    stake: number;
    unitStake?: number;
    id: number;
}